import { render, staticRenderFns } from "./payProjectDeptDataSingle.vue?vue&type=template&id=96dc09e6&scoped=true&"
import script from "./payProjectDeptDataSingle.vue?vue&type=script&lang=js&"
export * from "./payProjectDeptDataSingle.vue?vue&type=script&lang=js&"
import style0 from "./payProjectDeptDataSingle.vue?vue&type=style&index=0&id=96dc09e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96dc09e6",
  null
  
)

export default component.exports